<script lang="ts">
  import { notifications } from '../stores/notifications';
  import { fly } from 'svelte/transition';
  export let notification: import('../stores/notifications').Notification;
  export let onclose: () => void = () => {};

  function handleClose() {
    onclose();
  }

  $: iconClass = {
    success: 'text-green-500',
    error: 'text-red-500',
    warning: 'text-yellow-500',
    info: 'text-blue-500'
  }[notification.type];

  $: bgClass = {
    success: 'bg-green-50 border-green-200',
    error: 'bg-red-50 border-red-200',
    warning: 'bg-yellow-50 border-yellow-200',
    info: 'bg-blue-50 border-blue-200'
  }[notification.type];

  $: icon = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  }[notification.type];
</script>

<div
  class="notification {bgClass}"
  transition:fly={{ x: 300, duration: 300 }}
  role="alert"
  aria-live="polite"
>
  <div class="notification-content">
    <span class="notification-icon {iconClass}" aria-hidden="true">{icon}</span>
    <span class="notification-message">{notification.message}</span>
    <button
      class="notification-close"
      on:click={handleClose}
      aria-label="Close notification"
    >
      ×
    </button>
  </div>
</div>

<style>
  .notification {
    @apply border rounded-lg shadow-lg p-4 mb-2 max-w-md;
  }

  .notification-content {
    @apply flex items-center space-x-3;
  }

  .notification-icon {
    @apply flex-shrink-0 text-lg font-semibold;
  }

  .notification-message {
    @apply flex-1 text-sm text-gray-800;
  }

  .notification-close {
    @apply flex-shrink-0 text-gray-400 hover:text-gray-600 text-xl leading-none;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-left: 8px;
  }
</style>